/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-cycle */
/* eslint-disable camelcase */
import styled from '@emotion/styled';
import { ui, define, s } from '@owenscorning/pcb.alpha';

import { highlightSettingsSection } from '../../../../OC/PageBuilder/utilities/shared';
import createSizes from '../../../../OC/PageBuilder/utilities/sizes';
import { H2 } from '../../../../OC/oc-h';
import { Screens } from '../../../../PageBuilder/editing/Viewport';
import { connectLocation } from '../../../../location/LocationConnectors';
import { Renderer as Table } from '../Page/Table';

const getTableCell = (text, isBold) => ({
  content: {
    ops: [
      {
        attributes: { bold: isBold },
        insert: text,
      },
    ],
  },
});

const getTableRow = (attribute, value) => {
  // filter out hidden values for the editor preview's sake,
  // flatten out what remains (if anything) to a string
  const filteredValue = value?.filter?.(v => !v.__hidden) ?? value;
  if (filteredValue?.length === 0) return null;
  const flattenedValue = value?.[0]?.value ?? value;
  if (!flattenedValue) return null;
  return [getTableCell(attribute, true), getTableCell(flattenedValue, false)];
};

const getTableRows = t => {
  const {
    warranty,
    wind_resistance,
    algae_resistance,
    nominal_size,
    exposure,
    shingles_per_sq,
    bundles_per_sq,
    coverage_per_sq,
  } = Board.settings.attributes;

  return [
    [getTableCell(t('shingles.property_unit'), true), getTableCell(t('shingles.value'), true)],
    getTableRow(t('shingles.warranty'), warranty),
    getTableRow(t('shingles.wind_resistance'), wind_resistance),
    getTableRow(t('shingles.algae_resistance'), algae_resistance),
    getTableRow(t('shingles.nominal_size'), nominal_size),
    getTableRow(t('shingles.exposure'), exposure),
    getTableRow(t('shingles.shingles_per_sq'), shingles_per_sq),
    getTableRow(t('shingles.bundles_per_sq'), bundles_per_sq),
    getTableRow(t('shingles.coverage_per_sq'), coverage_per_sq),
  ].filter(row => row !== null);
}

const getTableData = t => [
  {
    rows: getTableRows(t),
    type: 'Body',
  },
];

const Sizes = createSizes();
const Width = Sizes.m;
const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto 32px auto;
  width: ${({ width }) => `${width.Mobile}px`};
  @media (min-width: ${Screens.Tablet}px) {
    width: ${({ width }) => `${width.Tablet}px`};
  }
  @media (min-width: ${Screens.Desktop}px) {
    width: ${({ width }) => `${width.Desktop}px`};
  }
`;

const HeaderSmallerText = styled.span`
  font-size: 16px;
`

const Renderer = connectLocation(({ t }) => (
  <TableContainer width={Width}>
    <H2 font="body">
      {t('shingles.technical_characteristics')} <HeaderSmallerText>{t('shingles.nominal_values')}</HeaderSmallerText>
    </H2>
    <Table alignment="center" containerSize="m" table={getTableData(t)} />
  </TableContainer>
));

const TechnicalCharacteristicsTable = define`Technical Characteristics Table`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/Table`,
  view: <Renderer />,
  edit: {
    [s._]: ui`Tip`.of('Technical Characteristics come from Attributes in Settings')({ noTopMargin: true }),
    [s._]: ui`RawLink`.of('Go to settings')({
      onClick: () => {
        highlightSettingsSection('sidebar-pane', 'attributes');
      },
      noTopMargin: true,
      icon: 'external-link',
    }),
  },
});

export default TechnicalCharacteristicsTable;
